import { FC } from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import Loader from 'components/Loader';

import ButtonRow from '../components/ButtonRow';
import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import { useCompanyCreditCards } from '../hooks/useCompanyCreditCards';
import cutCardsIcon from './images/cut-cards.svg';
import idIcon from './images/id.svg';
import ninjaIcon from './images/ninja.svg';
import locales from './locales';
import { Timeline } from './styles';

const SecurityWarning: FC = () => {
  const { creditCards, loading } = useCompanyCreditCards();

  let title = locales.titleCloseSecurely;
  let body = locales.bodyCloseSecurely;
  let firstStep = locales.verifyIdentity;
  let secondStep = locales.cutCards;
  let secondIcon = cutCardsIcon;

  if (creditCards.length === 0) {
    title = locales.titleIdentityCheck;
    body = locales.titleIdentityCheck;
    secondIcon = ninjaIcon;
    firstStep = locales.takeId;
    secondStep = locales.askSelfie;
  }

  if (creditCards.length === 1) {
    secondStep = locales.cutCard;
  }

  return (
    <Wrapper>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Title>{title}</Title>
          <Text>{body}</Text>
          <Timeline>
            <Timeline.Step
              description={firstStep.description}
              icon={idIcon}
              title={firstStep.title}
            />
            <Timeline.Step
              description={secondStep.description}
              hasTrailingLine={false}
              icon={secondIcon}
              title={secondStep.title}
            />
          </Timeline>
          <ButtonRow>
            <Button
              as={Link}
              icon="arrow-right"
              iconPosition="left"
              to="/company/account-closure/identity-check"
            >
              {locales.next}
            </Button>
          </ButtonRow>
        </>
      )}
    </Wrapper>
  );
};

export default SecurityWarning;
